import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { OldInput } from 'src/domains/layouts/shared/formComponents/input/OldInput';
import { ErrorMessageBar } from 'src/domains/layouts/shared/formComponents/FormComponents.style';

export const NotificationPageCtaButtonOptions = observer((): React.ReactElement | null => {
    const { notificationPageState } = useAppStateContext();
    return (
        <>
            {notificationPageState.actionTemplate.value === 'direct-link' ? (
                <OldInput
                    label='Button destination link'
                    status={notificationPageState.ctaUrlStatus}
                    formInputState={notificationPageState.ctaUrl}
                    model={notificationPageState.ctaUrlModel}
                    dataTest='set-link'
                />
            ) : null}
            {notificationPageState.actionTemplate.value === 'event-id' ? (
                <OldInput
                    label='Button event id'
                    status={notificationPageState.eventIdStatus}
                    formInputState={notificationPageState.eventId}
                    model={notificationPageState.eventIdModel}
                    dataTest='set-event-id'
                />
            ) : null}
            {notificationPageState.actionTemplate.value === 'competition-id' ? (
                <>
                    <OldInput
                        label='Button competition id'
                        status={notificationPageState.competitionIdStatus}
                        formInputState={notificationPageState.competitionId}
                        model={notificationPageState.competitionIdModel}
                        dataTest='set-competition-id'
                    />
                    <OldInput
                        label='Button sport'
                        status={notificationPageState.sportStatus}
                        formInputState={notificationPageState.sport}
                        model={notificationPageState.sportModel}
                        dataTest='set-sport'
                    />

                    {notificationPageState.competitionSport.errorMessage !== null ? (
                        <ErrorMessageBar>{notificationPageState.competitionSport.errorMessage}</ErrorMessageBar>
                    ) : null}
                </>
            ) : null}
            {notificationPageState.actionTemplate.value === 'casino-game-id' ? (
                <OldInput
                    label='Button casino game id'
                    status={notificationPageState.casinoGameIdStatus}
                    formInputState={notificationPageState.casinoGameId}
                    model={notificationPageState.casinoGameIdModel}
                    dataTest='set-casino-game-id'
                />
            ) : null}
            {notificationPageState.actionTemplate.value === 'sport' ? (
                <OldInput
                    label='Button sport'
                    status={notificationPageState.sportStatus}
                    formInputState={notificationPageState.sport}
                    model={notificationPageState.sportModel}
                    dataTest='set-sport'
                />
            ) : null}
        </>
    );
});
